export interface UserViewVersion {
  userViewVersionId: string;
  userId: string;
  versionId: string;
  viewNotesCount: string;
  viewApplicationCount: string;
  lastAccessedDate: Date;
}
